
import { defineComponent, ref } from "vue";
import axios from "axios";
export default defineComponent({
  name: "HomeView",
  components: {},
  setup() {
    const nify = ref("");
    const ndfy = ref("");
    const ntfy = ref("");
    const sendForm = () => {
      const payload = { ndfy: ndfy.value, nify: nify.value, ntfy: ntfy.value };
     // const testENV = "http://5.9.102.3:4545/manual-daily-prices";
    //  const testENV = "http://localhost:4545/manual-daily-prices";
     const testENV ="https://dailyyieldapi.norrenberger.com/manual-daily-prices"
      axios
        .post(testENV, payload)
        .then((response) => {
          alert("Succesfully Updated");
          console.log(response);
        })
        .catch((error) => {
          alert("An Error Occured");
          console.log(error);
        });
      ndfy.value = "";
      nify.value = "";
      ntfy.value = ""
    };
    return { ndfy, nify, ntfy, sendForm };
  },
});
